export function today() {
  const d = new Date();
  return d.getFullYear() + '-' +
    String(d.getMonth() + 1).padStart(2, '0') + '-' +
    String(d.getDate()).padStart(2, '0');
}
export function nowMonth() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`; }

export function fmtDate(d) {
  if (!d) return '—';
  const [y, m, day] = d.split('-');
  return `${day}/${m}/${y}`;
}

export const CURRENCIES = ['PKR', 'USD', 'GBP', 'AED'];
// rough fallbacks (PKR per 1 unit) used only if the live rate can't be fetched
export const FALLBACK_RATES = { PKR: 1, USD: 280, GBP: 355, AED: 76 };

export function fmtAmt(n, currency = 'PKR') {
  if (n === null || n === undefined || n === '') return '—';
  const num = Number(n);
  if (isNaN(num)) return '—';
  if (currency === 'USD') return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (currency === 'GBP') return '£' + num.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (currency === 'AED') return 'AED ' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return 'PKR ' + Math.round(num).toLocaleString('en-PK');
}

export function ordinal(n) {
  const s = ['th','st','nd','rd'];
  const v = n % 100;
  return n + (s[(v-20)%10] || s[v] || s[0]);
}

export function getMonthLabel(ym) {
  if (!ym) return '';
  const [y, m] = ym.split('-');
  return new Date(y, m-1, 1).toLocaleString('default', { month: 'long', year: 'numeric' });
}

export function getDueDateInMonth(day, ym) {
  const [y, m] = (ym || nowMonth()).split('-');
  return `${y}-${m}-${String(day).padStart(2,'0')}`;
}

export function isDueTodayInMonth(day) {
  return getDueDateInMonth(day, nowMonth()) === today();
}

export function monthsRange(n = 6) {
  const months = [];
  const d = new Date();
  for (let i = n-1; i >= 0; i--) {
    const dt = new Date(d.getFullYear(), d.getMonth() - i, 1);
    months.push(`${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}`);
  }
  return months;
}

export async function fetchUsdRate() {
  try {
    const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
    const data = await res.json();
    return data.rates?.PKR || null;
  } catch {
    return null;
  }
}

// PKR per 1 unit of each supported currency, from one USD-base fetch.
// PKR per GBP = (PKR per USD) / (GBP per USD); same for AED.
export async function fetchRatesPKR() {
  try {
    const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
    const data = await res.json();
    const r = data.rates || {};
    const usdPkr = r.PKR;
    if (!usdPkr) return { ...FALLBACK_RATES };
    return {
      PKR: 1,
      USD: usdPkr,
      GBP: r.GBP ? usdPkr / r.GBP : FALLBACK_RATES.GBP,
      AED: r.AED ? usdPkr / r.AED : FALLBACK_RATES.AED,
    };
  } catch {
    return { ...FALLBACK_RATES };
  }
}

// Convert an amount in `currency` to PKR using a rates map from fetchRatesPKR().
export function toPKR(amount, currency, rates) {
  const n = Number(amount) || 0;
  const cur = currency || 'PKR';
  const rate = (rates && rates[cur] != null) ? rates[cur]
             : (FALLBACK_RATES[cur] != null ? FALLBACK_RATES[cur] : 1);
  return n * rate;
}

// Returns previous month label — invoices generated in April are for March's work
export function getBillingMonthLabel() {
  const d = new Date();
  const prev = new Date(d.getFullYear(), d.getMonth() - 1, 1);
  return prev.toLocaleString('default', { month: 'long', year: 'numeric' });
}

// Invoice title format: "Padel Edge | March 2026 | Invoice"
export function getInvoiceNumber(clientName) {
  const name = (clientName || 'Client').trim();
  const month = getBillingMonthLabel();
  return `${name} | ${month} | Invoice`;
}

// Calculate due date: 3 business days after issueDate,
// but if client has a fixed dueDay in the month, use whichever is LATER.
// e.g. if dueDay=1 and invoice issued on 25th, the 1st hasn't passed yet → use 1st
// If invoice issued on 1st, 3 business days later = 4th (skipping weekends)
export function calcInvoiceDueDate(issueDateStr, clientDueDay) {
  const issue = new Date(issueDateStr);

  // 3 business days from issue date
  let count = 0, d = new Date(issue);
  while (count < 3) {
    d.setDate(d.getDate() + 1);
    const dow = d.getDay(); // 0=Sun,6=Sat
    if (dow !== 0 && dow !== 6) count++;
  }
  const threeBizDays = new Date(d);

  // If client has a fixed monthly due day
  if (clientDueDay) {
    const dayNum = parseInt(clientDueDay);
    // Try the due day in the SAME month as issue
    let dueDateSameMonth = new Date(issue.getFullYear(), issue.getMonth(), dayNum);
    // If that day has already passed (or is today), use next month
    if (dueDateSameMonth <= issue) {
      dueDateSameMonth = new Date(issue.getFullYear(), issue.getMonth() + 1, dayNum);
    }
    // Return whichever is later: 3 biz days vs fixed due day
    return threeBizDays >= dueDateSameMonth ? threeBizDays : dueDateSameMonth;
  }

  return threeBizDays;
}

export function fmtDueDate(dateObj) {
  if (!dateObj) return '';
  const d = dateObj instanceof Date ? dateObj : new Date(dateObj);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}
